<template>
  <div class="bulb page-wrapper">
    <div class="container">
      <div class="row">
        <div style="overflow:hidden">
          <el-row class="section1" :gutter="120">
            <el-col :span="12" :xs="{ span: 24 }">
              <img src="../../assets/air_img.png" alt="">
            </el-col>
            <el-col :span="12" :xs="{ span: 24 }">
              <h3>空调智能方案</h3>
              <p>远程控制  |  语音控制   |  童锁保护  |  定时开关</p>
              <div class="feature">
                <div>
                  <div>
                    <img src="../../assets/icon_zdh.png" alt="">
                    <label for="">自动化</label>
                  </div>
                  <div>
                    <img src="../../assets/icon_yjzx.png" alt="">
                    <label for="">一键执行</label>
                  </div>
                  <div>
                    <img src="../../assets/icon_dssz.png" alt="">
                    <label for="">预约定时</label>
                  </div>
                  <div>
                    <img src="../../assets/icon_sskz.png" alt="">
                    <label for="">实时操控</label>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="../../assets/icon_yykz.png" alt="">
                    <label for="">语音控制</label>
                  </div>
                  <div>
                    <img src="../../assets/icon_bytx.png" alt="">
                    <label for="">保养提醒</label>
                  </div>
                  <div>
                    <img src="../../assets/icon_dsjs.png" alt="">
                    <label for="">倒数计时</label>
                  </div>
                  <div>
                    <img src="../../assets/icon_qqqh.png" alt="">
                    <label for="">情景切换</label>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="split"></div>
    <div class="container">
      <div class="row">
        <img class="section2" src="../../assets/air_fe.png" alt="">
      </div>
    </div>
  </div>  
</template>

<script>
export default {

}
</script>


<style lang="scss" scoped>
.section1 {
  margin: 40px 0 60px;
  .el-col {
    position: relative;
    img {
      width: 100%;
    }
  }
  .el-col:last-child {
    h3 {
      font-size: 28px;
      font-weight: normal;
      margin-bottom: 16px;
    }
  }
  .feature {
    margin-top: 60px;
    & > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 36px;
      label {
        display: block;
        margin-top: 16px;
      }
    }
  }
}
.section2 {
  margin: 40px 0;
  max-width: 100%;
}
.section1 .feature > div > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100px;
  justify-content: space-between;
  img {
    width: auto;
  }
}

.split {
  height: var(--margin-small);
  background-color: #ECECEC;
}
</style>